import React, { Fragment, useContext } from "react";
import { Grid, Card, Typography, Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  cardstyle: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginBottom: "0.1rem",
    minHeight: "calc(100vh - 26.9rem)",
    maxHeight: "100%",
  },
  griditemhead: {
    display: "flex",
    alignItems: "center",
    margin: "0rem 0rem 1rem 0rem",
  },
  griditemheadend: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    margin: "0rem 0rem 1rem 0rem",
  },
  containerhead: {
    // borderBottom: "1px solid #d9d9d9",
  },
  gridcontent: {
    borderBottom: "1px solid #d9d9d9",
    margin: "0rem 0.3rem",
  },
  servicename: {
    margin: "0.7rem 0rem",
    fontWeight: 200,
    color: "#595a5a",
  },
  servicetype: {
    margin: "0.7rem 0rem",
    fontWeight: 400,
    color: "#595a5a",
  },
  fontService: {
    fontWeight: 700,
    color: "#595a5a",
    fontSize: "1.2rem",
  },
  itemcontent: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
  },
  icon: { color: "#828282" },
  addbtn: {
    padding: "0.5rem 3rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#98a8c1",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#98a8c1",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
    borderRadius: 8,
  },
  subhead: {
    margin: "0.7rem 0rem",
    fontWeight: 700,
    color: "#595a5a",
  },
  check: {
    marginRight: "1rem",
    "& .MuiFormControlLabel-labelPlacementStart": {},
  },
  fonttype: {
    fontWeight: 400,
    color: "#595a5a",
    marginRight: "1rem",
  },
  gridtype: {
    borderTop: "1px solid #d9d9d9",
    borderBottom: "1px solid #d9d9d9",
    backgroundColor: "#f1f1f1",
  },
  gridcontentend: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  nodata: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "calc(100vh - 36rem)",
    borderTop: "1px solid #d9d9d9",
  },
}));

const ManageUsage = ({ data, onChange }) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  return (
    <Fragment>
      <Grid item xs={12}>
        <Card className={classes.cardstyle}>
          <div style={{ margin: "1rem 2rem 2rem 2rem" }}>
            <Grid container className={classes.containerhead}>
              <Grid item xs={8} className={classes.griditemhead}>
                <Typography className={classes.fontService}>
                  Service List
                </Typography>
              </Grid>
              <Grid item xs={2} className={classes.griditemheadend}>
                <Typography className={classes.fonttype}>Public</Typography>
              </Grid>
              <Grid item xs={2} className={classes.griditemheadend}>
                <Typography className={classes.fonttype}>Contract</Typography>
              </Grid>
            </Grid>
            <Grid container>
              {data.length !== 0 ? (
                data.map((rs, index) => {
                  return (
                    <Fragment key={rs._id}>
                      {data[index - 1] &&
                      data[index - 1].type === rs.type ? null : (
                        <Grid item xs={12} className={classes.gridtype}>
                          <Typography
                            className={classes.servicetype}
                            style={{ marginLeft: "0.7rem" }}
                          >
                            {rs.type.charAt(0).toUpperCase()}
                            {rs.type.slice(1)}
                          </Typography>
                        </Grid>
                      )}
                      <Grid
                        item
                        xs={8}
                        style={{
                          backgroundColor:
                            index % 2 === 1 ? "#f9f9f9" : "#FFFFFF",
                        }}
                      >
                        <Typography
                          className={classes.servicename}
                          style={{ marginLeft: "0.3rem" }}
                        >
                          {`${index + 1}. ${rs.name}`}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        className={classes.gridcontentend}
                        style={{
                          backgroundColor:
                            index % 2 === 1 ? "#f9f9f9" : "#FFFFFF",
                        }}
                      >
                        <Checkbox
                          className={classes.check}
                          checked={rs.user_roles.includes("public")}
                          onChange={(e) => {
                            onChange(index, rs, "public");
                          }}
                          color="primary"
                          inputProps={{
                            "aria-label": "secondary checkbox",
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        className={classes.gridcontentend}
                        style={{
                          backgroundColor:
                            index % 2 === 1 ? "#f9f9f9" : "#FFFFFF",
                        }}
                      >
                        <Checkbox
                          className={classes.check}
                          color="primary"
                          onChange={(e) => {
                            onChange(index, rs, "contract");
                          }}
                          checked={rs.user_roles.includes("contract")}
                          inputProps={{
                            "aria-label": "secondary checkbox",
                          }}
                        />
                      </Grid>
                    </Fragment>
                  );
                })
              ) : (
                <div className={classes.nodata}> {lang.NoService}</div>
              )}
            </Grid>
          </div>
        </Card>
      </Grid>
    </Fragment>
  );
};

export default ManageUsage;
